import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { DsButtonVariants, DsTooltipPosition, Icons } from '@levelaccess/design-system';
import { TranslateService } from '@client/app/translate/translate.service';
import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';

export interface ITooltipCellConfig extends ICellConfig {
  tooltipPlacement?: DsTooltipPosition;
  icon?: Icons;
  ariaLabel?: string;
}

const defaultConfig: ITooltipCellConfig = {
  tooltipPlacement: DsTooltipPosition.right,
  icon: Icons.CircleInfo,
};

@Component({
  selector: 'table-cell-tooltip',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,

  template: `
    <button
      #tooltipRef
      ds-button
      [variant]="DsButtonVariants.microAction"
      data-test-id="table-cell-tooltip"
      [microActionIcon]="config.icon"
      [ds-tooltip]="config.translate ? (config.text | translate) : config.text"
      [tooltipPlacement]="config.tooltipPlacement"
      [attr.aria-label]="ariaLabel"
    ></button>
  `,
})
export class TooltipCellComponent extends BaseCellComponent implements OnInit {
  @ViewChild('tooltipRef', { read: ElementRef })
  public element: ElementRef<HTMLElement>;
  @Input() public config: ITooltipCellConfig;

  public ariaLabel: string;

  private readonly translateService: TranslateService = inject(TranslateService);

  protected readonly DsTooltipPosition: typeof DsTooltipPosition = DsTooltipPosition;
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  protected readonly Icons: typeof Icons = Icons;

  public ngOnInit(): void {
    this.config = { ...defaultConfig, ...this.config };
    this.ariaLabel = this.buildAriaLabel();
  }

  private buildAriaLabel(): string {
    const labelKey = this.config.ariaLabel ?? 'scan_error_tooltip_label';
    const shouldTranslateLabel = this.config.translate || !this.config.ariaLabel;
    const label = shouldTranslateLabel ? this.translateService.instant(labelKey) : labelKey;
    const errorText = this.config.translate ? this.translateService.instant(this.config.text) : this.config.text;
    return `${label}: ${errorText}`;
  }
}
